import { ComponentProps, ReactNode } from "react";

interface CardContainerProps extends ComponentProps<"div"> {
  title: string;
  titleAddon?: ReactNode; // rendered inline, right after the title
  disabled?: boolean;
  withoutOpacity?: boolean;
  childrenClassName?: string;
}

const CardContainer = (props: CardContainerProps) => {
  const {
    title,
    titleAddon,
    disabled,
    withoutOpacity,
    className,
    children,
    childrenClassName,
    ...rest
  } = props;

  return (
    <div
      className={`p-4 rounded-md border border-pelorous flex flex-col gap-5 ${
        withoutOpacity ? "bg-white" : "bg-white/50"
      } ${disabled ? "opacity-50 pointer-events-none" : ""} ${className ?? ""}`}
      {...rest}
    >
      {titleAddon ? (
        <div className="flex items-center gap-2">
          <h2 className="text-lg leading-5 text-pelorous font-bold">{title}</h2>
          {titleAddon}
        </div>
      ) : (
        <h2 className="text-lg leading-5 text-pelorous font-bold">{title}</h2>
      )}
      <div className={childrenClassName}>{children}</div>
    </div>
  );
};

export default CardContainer;
